import TargetTable from "./components/TargetTable";

const Target = () => {
  return <TargetTable />;
};

export default Target;
